// @flow
import { createAction } from 'redux-actions';

export const mbtSuccessAction = createAction('MBT_SUCCESS');
export const mbtErrorAction = createAction('MBT_ERROR');
export const mbtStartAction = createAction('MBT_START');
